<template>

	<app-boards board-key="consulting_services"></app-boards>

</template>

<script>
import AppBoards from "../../components/boards/appBoards";
export default {
	name: "consulting_services",
	components: {AppBoards},
}
</script>

<style scoped>

</style>